var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"learn-more-page"},[_c('blk-learn'),_vm._v(" "),_c('blk-why-balko'),_vm._v(" "),_c('blk-how-does-it-work')],1)}
var staticRenderFns = []

export { render, staticRenderFns }